// src/shared/apiPaths.js

const PATH_MAPS = {
    'subworkstream': 'svc-alpha-101',
    'workstream': 'svc-beta-202',
    'notification': 'svc-gamma-303',
    'initiatives': 'svc-delta-404',
    'user': 'svc-epsilon-505',
    'strategy': 'svc-zeta-606',
    'workstreamaction': 'svc-eta-707',
    'history':'svc-eba-808'
  };
  
  function getObfuscatedPath(originalPath) {
    return PATH_MAPS[originalPath] || originalPath;
  }
  
  function getOriginalPath(obfuscatedPath) {
    for (const original in PATH_MAPS) {
      if (PATH_MAPS[original] === obfuscatedPath) {
        return original;
      }
    }
    return obfuscatedPath;
  }
  
  module.exports = {
    getObfuscatedPath,
    getOriginalPath,
  };
  